import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM } from '../../../components/models';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';
import moment from 'moment';
import { EstrategiasService } from '../../../services/seguimiento/estrategias/estrategias.service';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ExcelService } from '../../../services/excel/excel.service';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { StrategiaService } from '../../../services/gestion/strategias/strategia.service';
import { ProyectosService } from '../../../services/gestion/proyectos/proyectos.service';

@Component({
  selector: 'app-estrategias',
  templateUrl: './estrategias.component.html',
  styleUrl: './estrategias.component.css'
})
export class EstrategiasComponent implements OnInit {
  private idPlanificacion: number = 0;

  /* Variables de filtros */
  public Filters = FiltersM;
  public aniosDisponibles = [];
  private objectives: any = [];
  public perspectives: any = [];
  public viewTabla = false;
  public modal1 = false;

  //Variables de datos
  private semaforo: any = [];
  public todasPer = true;
  public programasMostrar: any = [];
  private programas: any = [];

  public actividades: any = [];
  private programaModal = [];


  public Periodo = '';

  private edicion: boolean;
  private diasLab: any;

  constructor(
    public dataService: DataService,
    // private estrategiasService: EstrategiasService,
    private cookies: CookieService,
    private translateService: TranslateService,
    private excelService: ExcelService,
    private planificacionService: PlanificacionService,
    private objetivoService: ObjetivoService,
    private strategiaService: StrategiaService,
    private proyectosService: ProyectosService
  ) {
    this.obtenerDatos();
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
        "Sep","Oct","Nov","Dic"
      ]
    });
  }

  ngOnInit(): void { }

  // Obtención de datos
  private async obtenerDatos() {
    try {
      this.idPlanificacion = Number(this.cookies.get('idInstitucion'));
      const planeacionResponse = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion);
      this.obtenerFiltros(planeacionResponse);

      this.perspectives = this.ordenamientoId(this.perspectives);

      const objectives = [];
      for(const per of this.perspectives){
        const obj = await this.objetivoService.getObjectivesByPerspectiveGQL(per.id);
        objectives.push(...obj)
      }
      this.obtObjectives(objectives);

    } catch (error) {
    }
  }

  private seleccionarPeriodo(){
    this.aniosDisponibles.forEach(a => {
      a.series.forEach(m => m.check = false);
    });
    const ultimoAnio = this.aniosDisponibles[this.aniosDisponibles.length - 1];
    const ultimoPeriodo = ultimoAnio.series[ultimoAnio.series.length - 1];

    const periodoActual = moment().format('MMM-YY').toLowerCase();

    if (ultimoPeriodo.periodo === periodoActual) {
      const series = ultimoAnio.series;
      const indice = series.length - 1;

      if (indice > 0) {
        series[indice - 1].check = true;
        this.Periodo = series[indice - 1].periodo;
      }
    } else {
      ultimoPeriodo.check = true;
      this.Periodo = ultimoPeriodo.periodo;
    }
  }
  private obtenerFiltros(plan: any) {
    this.edicion = plan.isActive;
    this.diasLab = plan.business_days;
    this.aniosDisponibles = Meses.obtenerPeriodos(moment(plan.initial_date).toDate(), moment(plan.end_date).toDate());
    this.seleccionarPeriodo();
    for (const per of plan.perspectives) {
      this.perspectives.push({
        name: per.name,
        check: false,
        id: per.id,
      })
    }
    this.perspectives = this.ordenamientoId(this.perspectives);
    const sema = this.ordenamientoSem(plan.signals);
    if (Number(sema[sema.length - 1].value_01) > 100) {
      const valFinal = Number(sema[sema.length - 1].value_01);
      for (const sem of sema) {
        this.semaforo.push({
          valIn: Math.round((Number(sem.value_00) * 100) / valFinal) === 0 ? Math.round((Number(sem.value_00) * 100) / valFinal) : Math.round((Number(sem.value_00) * 100) / valFinal) + 0.1,
          valfin: Math.round((Number(sem.value_01) * 100) / valFinal),
          color: sem.color[0],
        });
      }
    } else {
      for (const sem of sema) {
        this.semaforo.push({
          valIn: Number(sem.value_00),
          valfin: Number(sem.value_01),
          color: sem.color[0],
        });
      }
    }
  }

  private async obtObjectives(array: any) {
    var aux = [], strat = [];
    for (const obj of array) {
      strat = strat.concat(obj.strategies.map(s => {return s.id}))
      aux.push(obj);
    }
    this.objectives = [];
    this.objectives = this.ordenamientoId(aux);

    strat = [...new Set(strat)];
    const strategies = [];
    for (let i = 0; i < strat.length; i += 10) {
      const batch = strat.slice(i, i + 10);
      const results = await this.strategiaService.getStrategyGQLFull(batch);
      strategies.push(...results);
    }

    this.obtProgramas(strategies);
  }

  private ordenamientoHis(array){
    array.sort(function (a: any, b: any) {
      let af = moment(Meses.escrituraPer(a.periodo), 'MM/DD/YY');
      let bf = moment(Meses.escrituraPer(b.periodo), 'MM/DD/YY');
      if (bf.isBefore(af)) {
        return 1;
      }
      if (af.isBefore(bf)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private obtProgramas(array: any) {
    let aux: any;
    let fechaini: any = undefined, fechafin: any = undefined;
    let auxA = [];

    array = this.ordenamientoId(array);
    this.programas = [];
    array = this.ordenamiento_estrategias(array);

    for (const prog of array) {
      for (const obj of this.objectives) {
        if (prog.objectives[0].id === obj.id) {
          let proyec: any = [];

          for (const pro of prog.projects) {
            // Procesar actividades
            for (const act of pro.activities) {
              let hist = [];

              // Obtener períodos planeados
              const fi = moment(act.initial_date.split('T')[0]).format('DD-MM-YYYY');
              const ff = moment(act.end_date.split('T')[0]).format('DD-MM-YYYY');
              const historicosCom = Meses.obtenerPlaneado(moment(fi, 'DD-MM-YYYY').toDate(), moment(ff, 'DD-MM-YYYY').toDate(), this.diasLab);

              let hisAg = 0;
              for(const his of historicosCom){
                const ex = act.historic.find(h => h.period === his.periodo);
                if(ex){
                  hist.push({
                    periodo: ex.period,
                    planeado: Number(ex.planned),
                    ejecutado: ex.executed,
                    id: ex.id,
                  });
                  hisAg++;
                }else{
                  hist.push({
                    periodo: his.periodo,
                    planeado: Number(his.planeado),
                    ejecutado: his.ejecutado,
                    id: his.id,
                  });
                }
              }
              if(hisAg !== act.historic.length){
                for(const h of act.historic){
                  const ex = hist.filter(hi => hi.periodo === h.period);
                  if(ex.length === 0){
                    hist.push({
                      periodo: h.period,
                      planeado: Number(h.planned),
                      ejecutado: h.executed,
                      id: h.id,
                    });
                  }
                }
              }
              hist = this.ordenamientoHis(hist);

              // Procesar adiciones
              let adAux = [];

              auxA.push({
                name: act.name,
                additions: this.ordenamientoAd(adAux),
                id: act.id,
                responsible: act.responsible,
                end_date: act.end_date,
                initial_date: act.initial_date,
                historico: hist,
              });
            }

            // Calcular fechas del proyecto           
            const fechas = this.obt_fechas(pro);
            if (fechaini === undefined) {
              fechaini = fechas[0];
            } else if (fechaini > fechas[0]) {
              fechaini = fechas[0];
            }

            if (fechafin === undefined) {
              fechafin = fechas[1];
            } else if (fechafin < fechas[1]) {
              fechafin = fechas[1];
            }

            if (auxA.length > 0) {
              proyec.push({
                name: pro.name,
                id: pro.id,
                weighing: pro.weighing,
                historicWeighing: pro.historicWeighing,
                description: pro.description,
                activities: this.ordenamientoId(auxA),
                responsable: pro.responsible,
                check: false,
              });
            }
            auxA = [];
          }

          aux = {
            id: prog.id,
            name: prog.name,
            description: prog.description,
            projects: this.ordenamientoId(proyec),
            objectives: this.ordenamientoId(prog.objectives)
          };

          // Verificar fechas
          if (fechafin !== undefined) {
            this.programas.push({
              programa: aux,
              avance: '',
              atraso: 0,
              fechaini: fechaini,
              fechafin: fechafin
            });
          }

          // Reset variables
          proyec = [];
          fechaini = undefined;
          fechafin = undefined;
          break; // Salir del loop de objectives una vez encontrado
        }
      }
    }

    // Actualizar programas mostrar
    this.programasMostrar = [];
    for (const pro of this.programas) {
      if (this.Mostrar(pro)) {
        this.programasMostrar.push(pro);
      }
    }
    this.viewTabla = true;
  }

  private obt_fechas(proy: any) {
    var fechaIni = undefined;
    var fechaFin = undefined;
    for (const act of proy.activities) {
      if (fechaFin === undefined) {
        fechaFin = act.end_date;
      } else if (fechaFin < act.end_date) {
        fechaFin = act.end_date;
      }

      if (fechaIni === undefined) {
        fechaIni = act.initial_date;
      } else if (fechaIni > act.initial_date) {
        fechaIni = act.initial_date;
      }
    }
    return [fechaIni, fechaFin];
  }

  // escritura de datos
  public escribirObj(per: any) {
    var objetivos = '';
    for (const objPro of per['objectives']) {
      if (objetivos === '') {
        objetivos += objPro.name;
      } else {
        objetivos += ', ' + objPro.name;
      }
    }
    return objetivos;
  }
  public escribirPer(prog: any, i: any) {
    var per = '';
    for (const objPro of prog['objectives']) {
      for (const obj of this.objectives) {
        if (Number(objPro.id) === Number(obj.id)) {
          per = obj.perspective.name;
        }
      }
    }

    if (i != 0) {
      var per2 = '';
      for (const objPro of this.programasMostrar[i - 1].programa.objectives) {
        for (const obj of this.objectives) {
          if (objPro.id === obj.id) {
            per2 = obj.perspective.name;
          }
        }
      }
      if (per != per2) {
        return per;
      }
    } else {
      return per;
    }

    return '';
  }

  private Mostrar(prog: any) {
    var existePer = false;
    if (this.todasPer) {
      existePer = true;
    } else {
      for (const objPro of prog.programa.objectives) {
        for (const obj of this.objectives) {
          if (objPro.id === obj.id) {
            for (const per of this.perspectives) {
              if (per.check && per.id === obj.perspective.id) {
                existePer = true;
              }
            }
            if (existePer) {
              break
            }
          }
        }
        if (existePer) {
          break
        }
      }
    }
    /** periodos */
    var existePeriodo = false;
    var per_sel = '';

    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          per_sel = mes.periodo;
        }
      }
    }

    if (prog.fechaini != undefined && prog.fechafin != undefined) {
      var per1 = Meses.getMesesN(moment(prog.fechaini).format('M')) + '-' + moment(prog.fechaini).format('YY');
      var per2 = Meses.getMesesN(moment(prog.fechafin).format('M')) + '-' + moment(prog.fechafin).format('YY');
      existePeriodo = Meses.compararPer(per1, per2, per_sel);
    }

    if (existePer )//&& existePeriodo)
      return true;
    return false;
  }

  public escribirDat(pro: any, tip: string) {
    var per = this.perSelected();
    const dat = pro.find(dat => per === dat.periodo);
    if (dat) {
      if (tip === 'plan') {
        return Number(dat.planeado);
      } else if (tip === 'ejec') {
        return dat.ejecutado;
      }
    }

    const lastPeriod = pro[pro.length-1];
    const fisrtPeriod = pro[0];

    let af = moment(Meses.escrituraPer(lastPeriod.periodo), 'MM/DD/YY');
    let bf = moment(Meses.escrituraPer(fisrtPeriod.periodo), 'MM/DD/YY');
    let acf = moment(Meses.escrituraPer(per), 'MM/DD/YY');

    if(bf.isBefore(acf)){
      if (tip === 'plan') {
        return Number(fisrtPeriod.planeado);
      } else if (tip === 'ejec') {
        return fisrtPeriod.ejecutado;
      }
    }else if(af.isAfter(acf)){
      return '-';
    }
    
    return 0;
  }

  public escribirDatPro(pro: any, tip: string) {
    var per = this.perSelected();
    var dias = 0, porcentajeplan = 0, porcentajeejec = 0;
    for (const act of pro.activities) {
      dias += this.obtenerDias(act.initial_date, act.end_date);
    }
    var suma = false;
    for (const act of pro.activities) {
      if (new Date(20 + per.split('-')[1], Meses.getMesesS(per.split('-')[0]) - 1) > new Date(act.end_date)) {
        suma = true;
      }
      for (const his of act.historico) {
        if (his.periodo === per || suma) {
          if (suma) {
            suma = false;
            var diasAct = this.obtenerDias(act.initial_date, act.end_date);
            var pesoAct = Number((diasAct * 100 / dias).toFixed(2));
            porcentajeplan += Number((100 * pesoAct / 100).toFixed(2));
            let perAct = Meses.obtnerPer(new Date(act.end_date))
            var ejeAct = 0;
            const hist = this.ordenamiendoHistorico(act.historico);
            for (const h of hist) {
              if (h.ejecutado !== null) {
                ejeAct = h.ejecutado;
                break;
              }
            }
            porcentajeejec += Number((ejeAct * pesoAct / 100).toFixed(2));
            break;
          } else {
            var diasAct = this.obtenerDias(act.initial_date, act.end_date);
            var pesoAct = Number((diasAct * 100 / dias).toFixed(2));
            porcentajeplan += Number((his.planeado * pesoAct / 100).toFixed(2));
            porcentajeejec += Number((his.ejecutado * pesoAct / 100).toFixed(2));
          }
        }
      }
    }
    if (tip === 'plan') {
      if (Number(porcentajeplan.toFixed(2)) >= 99.98) {
        return 100;
      }
      return Number(porcentajeplan.toFixed(2));
    }
    if (Number(porcentajeejec.toFixed(2)) >= 99.98) {
      return 100;
    }
    return Number(porcentajeejec.toFixed(2));
  }

  public obtenerDias(fIni: any, fFin: any) {
    let dias = 0;
    let inicio = moment(fIni);
    let fin = moment(fFin);
    let diff = fin.diff(inicio, 'days');

    if (diff === 0) {
      diff = 1;
    }

    switch (this.diasLab) {
      case 'Lunes-Viernes':
        let sem = Math.trunc(diff / 7);
        dias = diff - sem * 2;
        break;
      case 'Lunes-Sabado':
        let semSab = Math.trunc(diff / 7);
        dias = diff - semSab;
        break;
      case 'Lunes-Domingo':
        dias = diff;
        break;
    }

    return dias;
  }

  public pintarBord(eje: any, plan: any) {
    var porcentaje = undefined;
    var color = '';
    if (eje === 0 && plan !== 0 && this.dataService.company_name === 'Unión Popular') {//'Raiffeisen Latina' ){//
      return 'bordeNegro';
    } else if (eje === 0 && plan !== 0) {
      porcentaje = 0;
    } else if (eje !== 0 && eje !== null) {
      porcentaje = eje * 100 / plan;

    }
    if (porcentaje !== undefined) {
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (porcentaje >= valfin) {
        porcentaje = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (porcentaje >= ab && porcentaje <= sem.valfin) {
          color = sem.color;
          break;
        }
      }
      switch (color) {
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default: return 'bordeGris';
      }
    }
    return 'bordeGris'
  }

  public pintarBordPro(eje: any, plan: any) {
    if (eje !== 0) {
      var color = '';
      var por = eje * 100 / plan;
      var valfin = 0;
      for (const sem of this.semaforo) {
        if (valfin < sem.valfin) {
          valfin = sem.valfin
        }
      }
      if (por >= valfin) {
        por = valfin - 1;
      }
      for (const sem of this.semaforo) {
        var ab = sem.valIn;
        if (ab !== 0) {
          ab = ab - 0.1;
        }
        if (por >= ab && por <= sem.valfin) {
          color = sem.color;
          break;
        }
      }
      switch (color) {
        case 'verde': return 'bordeVerde';
        case 'azul': return 'bordeAzul';
        case 'amarillo': return 'bordeAmarillo';
        case 'naranja': return 'bordeNaranja';
        case 'rojo': return 'bordeRojo';
        default: return 'bordeGris';
      }
    }
    return 'bordeGris'
  }

  public avanceProg(prog: any, tipo: string) {
    var pondProyect = 0, pesoProg = 0, aportProg = 0, pesoTot = 0;
    const per = this.anSelected() + '';
    for (const pro of prog.programa.projects) {
      const avanPro = this.escribirDatPro(pro, 'ejec'), planPro = this.escribirDatPro(pro, 'plan');
      var peso = 0;
      if (pro.historicWeighing !== undefined && pro.historicWeighing.length !== 0) {
        for (const pon of pro.historicWeighing) {
          if (per === pon.period) {
            peso = pon.weighing;
            break;
          }
        }
      } else if (pro.weighing !== undefined) {
        peso = pro.weighing;
      }
      if (peso > 0) {
        const pesoPro = planPro * peso / 100;
        pesoTot += peso;
        pesoProg += pesoPro;

        if (planPro > 0) {
          aportProg = avanPro * pesoPro / planPro;
        }
        else {
          aportProg = 0;
        }
        pondProyect += aportProg;
      }
    }

    if (pesoTot > 0) {
      if (tipo === 'eje') {
        return Number((pondProyect * 100 / pesoTot).toFixed(2));
      } else {
        if (Number((pesoProg * 100 / pesoTot).toFixed(2)) >= 99.99) {
          return 100;
        }
        return Number((pesoProg * 100 / pesoTot).toFixed(2));
      }
    } else {
      // Si no hay pesos, intentar calcular directamente
      if (prog.programa.projects.length > 0) {
        let totalPlan = 0;
        let totalEjec = 0;
        for (const pro of prog.programa.projects) {
          totalPlan += this.escribirDatPro(pro, 'plan');
          totalEjec += this.escribirDatPro(pro, 'ejec');
        }
        if (tipo === 'eje') {
          return totalPlan > 0 ? Number((totalEjec / prog.programa.projects.length).toFixed(2)) : 0;
        } else {
          return totalPlan > 0 ? Number((totalPlan / prog.programa.projects.length).toFixed(2)) : 0;
        }
      }
      
      if (tipo === 'eje')
        return Number(pondProyect.toFixed(2));
      else
        return Number(pesoProg.toFixed(2));
    }
  }

  // Metodos de busqueda
  private perSelected() {
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          return mes.periodo;
        }
      }
    }
    return '';
  }

  private anSelected() {
    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          return an.anio;
        }
      }
    }
    return '';
  }

  // filtros
  public cambioAnio(event: any) {
    const per = event.periodo;

    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        mes.periodo === per ? mes.check = true : mes.check = false;
        if (mes.periodo === per) {
          this.Periodo = mes.periodo;
        }
      }
    }

    this.programasMostrar = [];
    for (const pro of this.programas) {
      if (this.Mostrar(pro)) {
        this.programasMostrar.push(pro);
      }
    }
  }

  public cambioPer(pers: any) {
    if(pers !== 'consolidado'){
      this.perspectives.forEach(res =>{ res.name === pers.name? res.check = !res.check: res.check = res.check});
      var all = 0;
      this.perspectives.forEach(res =>{ res.check? all++ : all = all });
      if(all === this.perspectives.length){
        this.todasPer = true
      }else{
        this.todasPer = false;
      }
    }else{
      if(this.todasPer){
        this.perspectives.forEach(res =>{ res.check = false});
      }else{
        this.perspectives.forEach(res =>{ res.check = true});
      }
      this.todasPer = !this.todasPer
    }
    // this.todasPer = false;
    // for (const per of this.perspectives) {
    //   per.id === pers.id ? per.check = !per.check : per.check = per.check;
    // }
    // var selec = 0; for (const per of this.perspectives) {
    //   if (per.check) {
    //     selec++;
    //   }
    // }
    // if (selec === (this.perspectives.length)) {
    //   this.todasPer = true;
    // }

    // this.programasMostrar = [];
    // for (const pro of this.programas) {
    //   if (this.Mostrar(pro)) {
    //     this.programasMostrar.push(pro);
    //   }
    // }
  }

  public selecAllPer() {
    for (const per of this.perspectives) {
      this.todasPer ? per.check = false : per.check = true;
    }
    this.todasPer = !this.todasPer;

    if (this.todasPer) {
      this.programasMostrar = [];
      for (const pro of this.programas) {
        if (this.Mostrar(pro)) {
          this.programasMostrar.push(pro);
        }
      }
    }
  }

  // Metodos de ordenamiento
  private ordenamientoId(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      return 0;
    });
    return array;
  }
  private ordenamiendoHistorico(hist: any) {
    hist.sort(function (a: any, b: any) {
      if (Number(a.periodo.split('-')[1] + Meses.getMesesNum(a.periodo.split('-')[0])) < Number(b.periodo.split('-')[1] + Meses.getMesesNum(b.periodo.split('-')[0]))) {
        return 1;
      }
      if (Number(a.periodo.split('-')[1] + Meses.getMesesNum(a.periodo.split('-')[0])) > Number(b.periodo.split('-')[1] + Meses.getMesesNum(b.periodo.split('-')[0]))) {
        return -1;
      }
      return 0;
    });
    return hist;
  }
  private ordenamientoAd(array: any) {
    array.sort(function (a: any, b: any) {
      if (a.name > b.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  public ordenamiento_estrategias(array: any) {
    var aux = [];
    for (const per of this.perspectives) {
      for (const obj of array) {
        if (Number(per.id) === this.objectivo_per(obj.objectives)) {
          aux.push(obj);
        }
      }
    }
    return aux;
  }

  public ordenamientoSem(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.value_00) > Number(b.value_00)) {
        return 1;
      }
      if (Number(a.value_00) < Number(b.value_00)) {
        return -1;
      }
      return 0;
    });
    return array;
  }

  private objectivo_per(obj) {
    for (const object of this.objectives) {
      if (obj.length !== 0 && object.id === obj[0].id) {
        return Number(object.perspective.id);
      }
    }
    return 0;
  }

  //Modal
  public openModal(pro: any) {
    this.actividades = pro.programa.projects;
    this.programaModal = pro;
    this.modal1 = true;
  }
  public closeModal() {
    this.modal1 = false;
  }

  public existAct(act: any) {
    var existePeriodo = true;
    var per_sel = '';

    for (const an of this.aniosDisponibles) {
      for (const mes of an.series) {
        if (mes.check) {
          per_sel = mes.periodo;
        }
      }
    }

    return existePeriodo;
    if (act.initial_date != undefined && act.end_date != undefined) {
      const fecI = moment(act.initial_date.split('T')[0]);
      const fecF = moment(act.end_date.split('T')[0]);
      const fecA = moment(Meses.escrituraPer(per_sel));
      existePeriodo = fecA.isBetween(fecI, fecF, undefined, '[]');
    }

  }
  public existPro(pro: any) {
    var existePeriodo = true;

    for (const act of pro.activities) {
      if (this.existAct(act)) {
        existePeriodo = true;
        break;
      }
    }

    return existePeriodo;
  }

  // Metodos de escritura Modal
  public escFech(fecha: any): string {
    if (!fecha) return '';
    return moment(fecha)
      .locale('es')
      .format('D MMM YY')
      .replace('.', '') // elimina el punto de abreviacion
      .toLowerCase();
  }

  public escFechPro(proy: any, dato: any) {
    var fecha_ini = undefined, fecha_fin = undefined;
    for (const act of proy.activities) {
      var fechaini = moment(act.initial_date.split('T')[0]), fechafin = moment(act.end_date.split('T')[0]);
      if (fecha_fin === undefined) {
        fecha_fin = fechafin;
      } else if (fecha_fin < fechafin) {
        fecha_fin = fechafin;
      }
      if (fecha_ini === undefined) {
        fecha_ini = fechaini;
      } else if (fecha_ini > fechaini) {
        fecha_ini = fechaini;
      }
    }

    switch (dato) {
      case 'fi': return this.escFech(fecha_ini);
      case 'ff': return this.escFech(fecha_fin);
      case 'di': return this.diasTot(fecha_ini, fecha_fin);
      case 'fie': return fecha_ini;
      case 'ffe': return fecha_fin;
      case 'die': return this.diasTot(fecha_ini, fecha_fin);
    }

    return '';

  }

  public diasTot(fechini: any, fechfin: any) {
    let inicio = moment(fechini);
    let fin = moment(fechfin);
    let Ndias = fin.diff(inicio, 'days');

    switch (this.diasLab) {
      case 'Lunes-Viernes':
        var sem = Math.trunc(Ndias / 7);
        Ndias = Ndias - sem * 2;
        break;
      case 'Lunes-Sabado':
        var sem = Math.trunc(Ndias / 7);
        Ndias = Ndias - sem;
        break;
      case 'Lunes-Domingo':
        Ndias = Ndias;
        break;
    }

    return Ndias;
  }

  public escResp(res: any) {
    if (res != null) {
      var nom = '' + res.position;//''+res.name+' '+res.first_surname+' '+res.second_surname;
      return nom;
    } else {
      return '';
    }
  }

  public oculMost(pro: any) {
    pro.check = !pro.check;
  }

  //Exportar excel
  public exportar_excel() {
    const title = 'Seguimiento: ' + this.translateService.instant('gestion.seguimiento.estrategias.estrategia') + ' de ' + this.Periodo;
    const header = ["Perspectiva", "Objetivos", "Estrategias", "Planeado", "Avance"]
    var data = [];
    var aux = [];
    for (var i = 0; i < this.programasMostrar.length; i++) {
      aux.push(this.escribirPer(this.programasMostrar[i].programa, i));
      aux.push(this.escribirObj(this.programasMostrar[i].programa));
      aux.push(this.programasMostrar[i].programa.name);
      aux.push(this.avanceProg(this.programasMostrar[i], 'plan'));
      aux.push(this.avanceProg(this.programasMostrar[i], 'eje'));
      data.push(aux);
      aux = [];
    }
    const NomArch = this.translateService.instant('gestion.seguimiento.estrategias.estrategia').toLowerCase();
    this.excelService.generateExcelProgramas(title, header, data, NomArch, this.semaforo);
  }

  public export_excel_p() {
    const title = 'Proyectos asociados';
    const header = ['Proyecto', 'Inicio', 'Días', 'Fin', 'Líder', 'Planeado', 'Ejecutado'];

    var data = [];
    var aux = [];
    aux.push('*' + this.programaModal['programa'].name);
    aux.push('');
    aux.push('');
    aux.push('');
    aux.push('');
    aux.push('');
    aux.push('');
    data.push(aux);
    aux = [];
    for (const pro of this.actividades) {
      if (this.existPro(pro)) {
        aux.push(pro.name);
        aux.push(this.escFechPro(pro, 'fie').format('DD/MM/YYYY'));
        aux.push(this.escFechPro(pro, 'die'));
        aux.push(this.escFechPro(pro, 'ffe').format('DD/MM/YYYY'));
        aux.push(this.escResp(pro.responsable));
        aux.push(this.escribirDatPro(pro, 'plan'));
        aux.push(this.escribirDatPro(pro, 'ejec'));
        data.push(aux);
        aux = [];
        for (const act of pro.activities) {
          if (this.existAct(act)) {
            aux.push('-' + act.name);
            aux.push(moment(act.initial_date.split('T')[0]).format('DD/MM/YYYY'));
            aux.push(this.diasTot(act.initial_date, act.end_date));
            aux.push(moment(act.end_date.split('T')[0]).format('DD/MM/YYYY'));
            aux.push(this.escResp(act.responsible));
            aux.push(this.escribirDat(act.historico, 'plan'));
            aux.push(this.escribirDat(act.historico, 'ejec') === null ? 'null' : this.escribirDat(act.historico, 'ejec'));
            data.push(aux);
            aux = [];
          }
        }
      }
    }
    const NomArch = 'proyectos_asociados';
    this.excelService.generateExcelProgramasPorg(title, header, data, NomArch, this.semaforo);
  }

  public clickFuera(event, modal) {
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      }, 600);
    }
  }
}
